export const life = {
  mounted() {
    this.methods('initViewer');
  },
  beforeDestroy() {
    this.methods('removeViewer');
  },
  updated() {
    // 用户在预览图片时不要打扰到
    if(!this.showing){
      this.viewer.update();
    }
  },
};
export const event = {
  // 用户点击独立模式的主体
  clickStandaloneBody(){
   this.methods('showStandalone')
  }
};
export const watch = {};
